// DTO → view-model parsers for the UAE Pass flow. Every response goes through a
// parser (even where the wire is already camelCase) so a future server rename
// breaks only this file, and consumers never touch a raw DTO.

import {
  UAE_PASS_CALLBACK_OUTCOME,
  type UaePassCallbackOutcome,
  type UaePassAuthorizeUrl,
  type UaePassLogoutUrl,
  type UaePassCallbackResult,
  type UaePassRegisterResult,
  type UaePassSignupPrefill,
  type LogoutResult,
} from '../types/authTypes'
import type {
  UaePassAuthorizeUrlDto,
  UaePassCallbackDto,
  UaePassLogoutUrlDto,
  UaePassRegisterDto,
  UaePassSignupPrefillDto,
  LogoutResponseDto,
} from './authContracts'

export function parseUaePassAuthorizeUrl(dto: UaePassAuthorizeUrlDto): UaePassAuthorizeUrl {
  return { authorizeUrl: dto.authorizeUrl }
}

export function parseUaePassLogoutUrl(dto: UaePassLogoutUrlDto): UaePassLogoutUrl {
  return { uaePassLogoutUrl: dto.uaePassLogoutUrl }
}

const KNOWN_OUTCOMES: readonly UaePassCallbackOutcome[] = Object.values(UAE_PASS_CALLBACK_OUTCOME)

function toOutcome(outcome: string): UaePassCallbackOutcome {
  return KNOWN_OUTCOMES.includes(outcome as UaePassCallbackOutcome)
    ? (outcome as UaePassCallbackOutcome)
    : UAE_PASS_CALLBACK_OUTCOME.EMAIL_EXISTS_USE_OTP
}

function parsePrefill(dto: UaePassSignupPrefillDto | undefined): UaePassSignupPrefill | null {
  if (!dto) return null
  return {
    firstName: dto.firstName,
    lastName: dto.lastName,
    email: dto.email,
    mobile: dto.mobile ?? null,
    hasEmiratesId: dto.hasEmiratesId,
  }
}

export function parseUaePassCallback(dto: UaePassCallbackDto): UaePassCallbackResult {
  return {
    outcome: toOutcome(dto.outcome),
    accessToken: dto.accessToken ?? null,
    refreshToken: dto.refreshToken ?? null,
    email: dto.email ?? null,
    message: dto.message ?? null,
    signupTicket: dto.signupTicket ?? null,
    prefill: parsePrefill(dto.prefill),
  }
}

export function parseUaePassRegister(dto: UaePassRegisterDto): UaePassRegisterResult {
  return {
    accessToken: dto.accessToken,
    refreshToken: dto.refreshToken,
    hasEmiratesId: dto.hasEmiratesId,
  }
}

export function parseLogout(dto: LogoutResponseDto): LogoutResult {
  return {
    success: dto.success,
    uaePassLogoutUrl: dto.uaePassLogoutUrl ?? null,
  }
}
